"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Mountains;

var _react = _interopRequireDefault(require("react"));

var _fenetreSlim = _interopRequireDefault(require("./assets/fenetre-slim.png"));

var _decor = _interopRequireDefault(require("./assets/decor.svg"));

require("./mountains.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function Mountains(_ref) {
  var width = _ref.width,
      height = _ref.height,
      style = _ref.style;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "mountains-container",
    style: _objectSpread({
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      backgroundColor: 'white',
      height: height,
      width: width
    }, style)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    id: "mountains",
    style: {
      position: 'relative',
      backgroundImage: "url(".concat(_decor["default"], ")"),
      height: height,
      width: width,
      // `calc(0.69 * ${height})`,
      maxWidth: "min(calc(0.9 * ".concat(height, "), 80vw)"),
      margin: 0,
      padding: 0 // clipPath: "url('#myClip')", // 'inset(1em round 15%)'

    }
  }, /*#__PURE__*/_react["default"].createElement("svg", {
    width: "0",
    height: "0",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("clipPath", {
    id: "myClip"
  }, /*#__PURE__*/_react["default"].createElement("rect", {
    x: "10",
    y: "10",
    width: "100",
    height: "90",
    rx: "20",
    ry: "20"
  })))), /*#__PURE__*/_react["default"].createElement("div", {
    //  src={fenetre}
    //  height="100%"
    //  width="100%"
    style: {
      position: 'absolute',
      backgroundImage: "url(".concat(_fenetreSlim["default"], ")"),
      height: 'calc(100% + 4px)',
      width: 'calc(100% + 4px)',
      left: -2,
      top: -2,
      backgroundSize: 'contain',
      backgroundRepeat: 'repeat-x',
      backgroundPosition: '0 0 0 0' // objectFit: "fill"

    }
  })));
}